import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import ElectricityApartmentAgreementsService, {
  ApartmentAgreement,
} from "services/electricity/electricity-apartment-agreements.service";

interface Props {
  apartment: ApartmentAgreement;
  onSaved: () => void;
  onCancel: () => void;
}

export default function CancelApartmentForm({ apartment, onSaved, onCancel }: Props) {
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await ElectricityApartmentAgreementsService.cancel(apartment.id);
      toast.success("Korteri leping tühistatud");
      onSaved();
    } catch {
      toast.error("Korteri tühistamine ebaõnnestus");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="border rounded p-3 mb-3 bg-light">
      <h5>Tühista tulevane korteri leping</h5>
      <p className="m-0">
        Kas oled kindel, et soovid tühistada korteri <b>{apartment.name}</b> lepingu?
      </p>

      <div className="d-flex mt-4">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={saving}>
          Tagasi
        </Button>
        <Button type="button" variant="danger" onClick={submit} disabled={saving} className="ml-2">
          {saving ? <Spinner size="sm" animation="border" /> : "Kinnita tühistamine"}
        </Button>        
      </div>
    </div>
  );
}
